import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import SpreadsheetDatabase from "@/pages/database/page";
import SicherheitPage from "@/pages/sicherheit/page";
import SeoArticlePage from "@/pages/seo-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/spreadsheet-database",
    element: <SpreadsheetDatabase />,
  },
  {
    path: "/oopbuy-sicherheit",
    element: <SicherheitPage />,
  },
  {
    path: "/oopbuy-sneaker-spreadsheet",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-fashion-spreadsheet",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-qc-fotos",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-versand-deutschland",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-kosten",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-erfahrungen",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-anfaenger",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-spar-tipps",
    element: <SeoArticlePage />,
  },
  {
    path: "/oopbuy-alternative",
    element: <SeoArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;